<template>
  <v-dialog
      v-model="showModal"
      max-width="1000"
      persistent
  >
    <v-card class="text-center px-2">
      <template v-if="errorMessage">
        <v-alert
            type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
<!--      <validation-observer-->
<!--          ref="validation"-->
<!--          v-slot="{ handleSubmit }"-->
<!--      >-->
        <v-card-title class="text-sm-left font-weight-bold pb-3" style="border-bottom: 1px solid #e9dfdf">
          <template>

            Tạo bộ phận
          </template>

          <v-spacer />

          <v-icon
              size="20"
              aria-label="Close"
              @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-form v-model="isFormValid">
            <div class="group-input mb-4">
              <ul>
                <template v-for="(department, index) in listCreateDepartment">
                  <li
                      :key="department.id"
                      :class="index == 0 ? 'list-input mt-5' : 'list-input'"
                  >
                    <v-row>
                      <div class="pt-5 px-4">
                        <span>Tên Bộ Phận *</span>
                      </div>
                      <v-col cols="9"
                             style="position: relative"
                             class="px-0 mr-5">
  <!--                      <validation-provider-->
  <!--                          v-slot="{ errors }"-->
  <!--                          class="mb-2"-->
  <!--                          :rules="[rules.required, rules.checkDuplicate]"-->
  <!--                          name="Tên bộ phân"-->
  <!--                          vid="tên bộ phận"-->
  <!--                      >-->
                          <v-text-field
                              v-model.trim="department.name"
                              label=""
                              color="primary"
                              filled
                              :rules="[rules.required, rules.checkDuplicate, rules.maxLength]"
                              dense
                              clearable
                              @keypress="changeInputText(index)"
                              @click:clear="changeInputText(index)"
                          />
                          <span

                              class="messages-error-duplicate"
                              v-if="department.isDuplicate">Tên bộ phận đã tồn tại. Vui lòng nhập lại!</span>
  <!--                      </validation-provider>-->
                      </v-col>
                      <v-col cols="1" class="pt-3 px-0">
                        <span>
                          <v-icon
                              class="btn-add-row-item"
                              v-if="index == 0"
                              @click="addRow">mdi-plus</v-icon>

                          <v-icon
                              style="padding-top: 4px"
                              size="30"
                              v-else
                              @click="deleteRow(index)"
                          >
                          mdi-delete
                        </v-icon>
                        </span>
                      </v-col>
                    </v-row>

                  </li>
                </template>
              </ul>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn
              style="color: black"
              class="ml-0"
              color="#F2F2F2"
              @click="hideModal"
          >
            Bỏ qua
          </v-btn>

          <v-btn
              :loading="loading"
              :disabled="!isFormValid"
              color="#7367F0"
              @click="saveDepartments"
          >
            Lưu
          </v-btn>
        </v-card-actions>
<!--      </validation-observer>-->
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const organizationMachineRepository = RepositoryFactory.get('organization_machine');

export default {

  data() {
    return {
      showModal: false,
      errorMessage: '',
      listCreateDepartment: [{name: '', isDuplicate: false}],
      rules: {
        required: value => value && !!value.trim() || 'Tên bộ phận là bắt buộc.',
        checkDuplicate: (value) => {
          if (this.listCreateDepartment.filter(e => e.name === value.trim()).length > 1) {
            return `Tên bộ phận đã tồn tại. Vui lòng nhập lại!`;
          } else {
            return true;
          }
        },
        maxLength: value => value.trim().length <= 255 || 'Tên bộ phận chỉ được nhập tối đa 255 kí tự'
      },
      isFormValid: true,
      loading: false
    }
  },
  computed: {

  },
  created() {
    Bus.$on('department-show-form', () => {
      this.showModal = true
    })
  },
  methods: {
    hideModal: function() {
      this.showModal = false
      this.listCreateDepartment = [
        {
          name: '',
          isDuplicate: false
        }
      ]
    },
    async saveDepartments() {
      this.loading = true
      const body = {
        name: this.listCreateDepartment.map(e => e.name)
      }
      const loading = this.$loading.show()
      let res = await organizationMachineRepository.create(body)
      if (res.success) {
        this.showModal = false;
        this.listCreateDepartment = [
          {
            name: '',
            isDuplicate: false
          }
        ]
        this.$swal({
          title: 'Cập nhật dữ liệu thành công!',
          timer: 1500,
          showConfirmButton: false,
          icon: 'success'
        })
        Bus.$emit('update-data-list-department')
      } else {
        let listItemDuplicate = res.errors;
        this.listCreateDepartment.forEach(e => {
          if(listItemDuplicate.includes(e.name)) {
            e.isDuplicate = true
          } else {
            e.isDuplicate = false
          }
        })
      }
      loading.hide()
      this.loading = false
    },
    addRow () {
      this.listCreateDepartment.push({
        name: '',
        isDuplicate: false
      })
    },
    deleteRow (index) {
      if (index > -1) this.listCreateDepartment.splice(index, 1)
    },
    changeInputText(index) {
      this.listCreateDepartment[index].isDuplicate = false;
    }
  },
  beforeDestroy() {
    Bus.$off('department-show-form')
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
.btn-add-row-item {
  padding: 8px;
  border-radius: 5px;
  border: 2px dashed #a39398;
}
.messages-error-duplicate {
  position: absolute;
  color: red;
  bottom: 8px;
  font-size: 12px;
  left: 10px;
}
</style>
